import { render, staticRenderFns } from "./SASBTable.vue?vue&type=template&id=6aa7a1ac"
import script from "./SASBTable.vue?vue&type=script&lang=js"
export * from "./SASBTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports